import {
	DELETE_DAMAGE_RECEIPT_LINE_ERROR,
	DELETE_DAMAGE_RECEIPT_LINE_SUCCESS,
	DELETE_DAMAGE_RECEIPT_LINE_REQUEST,
	GET_ONE_DAMAGE_RECEIPT_LINE_REQUEST,
	GET_ONE_DAMAGE_RECEIPT_LINE_SUCCESS,
	GET_ONE_DAMAGE_RECEIPT_LINE_ERROR,
	GET_ONE_DAMAGE_RECEIPT_LINE_DETAIL_REQUEST,
	GET_ONE_DAMAGE_RECEIPT_LINE_DETAIL_SUCCESS,
	GET_ONE_DAMAGE_RECEIPT_LINE_DETAIL_ERROR,
	ADD_DAMAGE_RECEIPT_LINE_REQUEST,
	ADD_DAMAGE_RECEIPT_LINE_SUCCESS,
	ADD_DAMAGE_RECEIPT_LINE_ERROR,
	UPDATE_DAMAGE_RECEIPT_LINE_REQUEST,
	UPDATE_DAMAGE_RECEIPT_LINE_SUCCESS,
	UPDATE_DAMAGE_RECEIPT_LINE_ERROR,
} from "./types.js";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const addDamageReceiptLine = (token, object) => (dispatch) => {
	dispatch({ type: ADD_DAMAGE_RECEIPT_LINE_REQUEST });
	return axios({
		method: "POST",
		url: `${BASEURL}create/damageReceiptLine`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: object,
	})
		.then((response) => {
			return dispatch({
				type: ADD_DAMAGE_RECEIPT_LINE_SUCCESS,
				payload: response?.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: ADD_DAMAGE_RECEIPT_LINE_ERROR,
				payload: error.response,
			});
		});
};

export const updateDamageReceiptLine = (token, shipHeaderId, object) => (dispatch) => {
	dispatch({ type: UPDATE_DAMAGE_RECEIPT_LINE_REQUEST });
	return axios({
		method: "PUT",
		url: `${BASEURL}update/damageReceiptLine/${shipHeaderId}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: {
			dataLine: object,
		},
	})
		.then((response) => {
			return dispatch({
				type: UPDATE_DAMAGE_RECEIPT_LINE_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: UPDATE_DAMAGE_RECEIPT_LINE_ERROR,
				payload: error.response,
			});
		});
};

export const getOneDamageReceiptLine = (token, id) => (dispatch) => {
	dispatch({ type: GET_ONE_DAMAGE_RECEIPT_LINE_REQUEST });

	return axios({
		method: "GET",
		url: `${BASEURL}getOne/damageReceiptLines/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
	})
		.then((response) => {
			return dispatch({
				type: GET_ONE_DAMAGE_RECEIPT_LINE_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: GET_ONE_DAMAGE_RECEIPT_LINE_ERROR,
				payload: error.response,
			});
		});
};

export const getOneDamageReceiptLineDetail = (token, id) => (dispatch) => {
	dispatch({ type: GET_ONE_DAMAGE_RECEIPT_LINE_DETAIL_REQUEST });
	return axios({
		method: "GET",
		url: `${BASEURL}getOne/damageReceiptLinesDetail/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
	})
		.then((response) => {

			return dispatch({
				type: GET_ONE_DAMAGE_RECEIPT_LINE_DETAIL_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: GET_ONE_DAMAGE_RECEIPT_LINE_DETAIL_ERROR,
				payload: error.response,
			});
		});
};

export const deleteDamageReceiptLine = (token, id) => (dispatch) => {
	dispatch({ type: DELETE_DAMAGE_RECEIPT_LINE_REQUEST });
	return axios({
		method: "DELETE",
		url: `${BASEURL}delete/damageReceiptLine/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
	})
		.then((response) => {
			return dispatch({
				type: DELETE_DAMAGE_RECEIPT_LINE_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: DELETE_DAMAGE_RECEIPT_LINE_ERROR,
				payload: error.response,
			});
		});
};
